import { get, intersection, size } from 'lodash-es'

import {
  ADMIN_AND_MANAGER,
  ADMIN_MANAGER_SALES,
  ADMIN_ONLY,
  ADMIN_SALES_MANAGER,
  ALL_OFFICE_ROLES,
  RoleEnum,
  RoleGroup,
  SUPER_ADMIN_ONLY,
} from '@/models'

import { EmmaPath } from '../router/paths'

export interface Permission {
  edit: RoleGroup
  view: RoleGroup
}

const authorizations: Record<string, Permission> = {}

// Initialize paths
authorizations[EmmaPath.CUSTOMER_LISTING] = { edit: [], view: [] }
authorizations[EmmaPath.CUSTOMER_PAGE] = { edit: [], view: [] }
authorizations[EmmaPath.CUSTOMER_NEW_LEADS] = { edit: [], view: [] }
authorizations[EmmaPath.CUSTOMER_NEW_LEADS_TRIAGE] = { edit: [], view: [] }
authorizations[EmmaPath.CUSTOMER_NEW_LEADS_TRIAGE_V2] = { edit: [], view: [] }
authorizations[EmmaPath.CUSTOMER_NEW_LEADS_TRIAGE_V4] = { edit: [], view: [] }
authorizations[EmmaPath.CUSTOMER_AUTO_BOOKINGS] = { edit: [], view: [] }
authorizations[EmmaPath.MOVE_MANAGER] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_BRANCH_LISTING] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_BRANCH_UPDATE] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_BRANCH_CREATE] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_TRUCK_LISTING] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_NPS_LISTING] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_REVIEWS] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_DIALPAD_STATS] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_BILLABLE_EFFICIENCY] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_CONTRACT_EFFICIENCY] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_DAMAGES] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_TRUCK_UPDATE] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_TRUCK_CREATE] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_EMPLOYEE_LISTING] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_RIPPLING_WORK_HOURS_LISTING] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_TRIP_TRACKER_LISTING] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_EMPLOYEE_CREATE] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_EMPLOYEE_UPDATE] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_MARKETING] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_MARKETING_EDIT] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_KPIS] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_BRANCH_KPIS] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_NPS] = { edit: [], view: [] }
authorizations[EmmaPath.REPORTS_MOVES] = { edit: [], view: [] }
authorizations[EmmaPath.REPORTS_MANAGER] = { edit: [], view: [] }
authorizations[EmmaPath.REPORTS_MARKETING] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_PROBLEMS_LOCATIONS] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_MOVE_REPORTS] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_PRICING_RULES] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_NOTIFICATION_RULES] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_ZIP_ZONES] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_CALENDAR_AVAILABILITIES] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_TRACKING_INCORRECT_MOVES] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_GENERAL] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_TUR] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_SALES] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_SALES_PIPELINE] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_REVENUE] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_REVENUE_DETAILS] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_OVER_TIME] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_SALES_DETAILS] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_SETTINGS] = { edit: [], view: [] }
authorizations[EmmaPath.CUSTOMER_CREATE] = { edit: [], view: [] }
authorizations[EmmaPath.MOVER_MOVES] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_SERVICE_ZONES] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_MAP] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_CRON_JOBS] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_MOVES_MAP] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_BOOKING_SIMULATOR] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_ESTIMATION_SIMULATOR] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_REASSIGNMENT_FORM] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_RELOCATION_TREND_MAP] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_LEADFERNO_CONVERSION] = { edit: [], view: [] }

// Assign known permissions
authorizations[EmmaPath.CUSTOMER_LISTING].view = ALL_OFFICE_ROLES
authorizations[EmmaPath.CUSTOMER_PAGE].edit = ADMIN_MANAGER_SALES
authorizations[EmmaPath.CUSTOMER_NEW_LEADS].view = ADMIN_MANAGER_SALES
// Triage v1 and v2 share the same audience as New Leads.
authorizations[EmmaPath.CUSTOMER_NEW_LEADS_TRIAGE].view = ADMIN_MANAGER_SALES
authorizations[EmmaPath.CUSTOMER_NEW_LEADS_TRIAGE_V2].view = ADMIN_MANAGER_SALES
authorizations[EmmaPath.CUSTOMER_NEW_LEADS_TRIAGE_V4].view = ADMIN_MANAGER_SALES
authorizations[EmmaPath.CUSTOMER_AUTO_BOOKINGS].view = ADMIN_MANAGER_SALES
authorizations[EmmaPath.MOVE_MANAGER].view = ALL_OFFICE_ROLES
authorizations[EmmaPath.MOVE_MANAGER].edit = ADMIN_AND_MANAGER
authorizations[EmmaPath.ADMIN_BRANCH_LISTING].view = ADMIN_ONLY
authorizations[EmmaPath.ADMIN_BRANCH_UPDATE].edit = ADMIN_ONLY
authorizations[EmmaPath.ADMIN_BRANCH_CREATE].edit = ADMIN_ONLY
authorizations[EmmaPath.REPORT_DAMAGES].view = ADMIN_AND_MANAGER
authorizations[EmmaPath.ADMIN_TRUCK_LISTING].view = ADMIN_AND_MANAGER
authorizations[EmmaPath.ADMIN_NPS_LISTING].view = ADMIN_AND_MANAGER
authorizations[EmmaPath.REPORT_REVIEWS].view = ADMIN_AND_MANAGER
authorizations[EmmaPath.REPORT_DIALPAD_STATS].view = ADMIN_AND_MANAGER
authorizations[EmmaPath.ADMIN_TRUCK_UPDATE].edit = ADMIN_AND_MANAGER
authorizations[EmmaPath.ADMIN_TRUCK_CREATE].edit = ADMIN_ONLY
authorizations[EmmaPath.ADMIN_TRUCK_CREATE].view = ADMIN_ONLY
authorizations[EmmaPath.ADMIN_EMPLOYEE_LISTING].view = ADMIN_AND_MANAGER
authorizations[EmmaPath.ADMIN_TRIP_TRACKER_LISTING].view = ADMIN_AND_MANAGER
authorizations[EmmaPath.ADMIN_RIPPLING_WORK_HOURS_LISTING].view = ADMIN_AND_MANAGER
authorizations[EmmaPath.ADMIN_EMPLOYEE_CREATE].edit = ADMIN_AND_MANAGER
authorizations[EmmaPath.ADMIN_EMPLOYEE_UPDATE].edit = ADMIN_AND_MANAGER
authorizations[EmmaPath.ADMIN_MARKETING].view = ADMIN_AND_MANAGER
authorizations[EmmaPath.ADMIN_MARKETING_EDIT].edit = ADMIN_ONLY
authorizations[EmmaPath.REPORT_NPS].view = ADMIN_MANAGER_SALES
authorizations[EmmaPath.REPORT_BRANCH_KPIS].view = ADMIN_MANAGER_SALES
authorizations[EmmaPath.REPORT_KPIS].view = ADMIN_MANAGER_SALES
authorizations[EmmaPath.REPORT_KPIS].edit = ADMIN_ONLY
authorizations[EmmaPath.REPORTS_MOVES].view = ADMIN_ONLY
authorizations[EmmaPath.ADMIN_PROBLEMS_LOCATIONS].view = ADMIN_MANAGER_SALES
authorizations[EmmaPath.ADMIN_MOVE_REPORTS].view = ADMIN_MANAGER_SALES
authorizations[EmmaPath.ADMIN_PRICING_RULES].view = ADMIN_ONLY
authorizations[EmmaPath.ADMIN_PRICING_RULES].edit = ADMIN_ONLY
authorizations[EmmaPath.ADMIN_NOTIFICATION_RULES].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_NOTIFICATION_RULES].edit = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_ZIP_ZONES].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_ZIP_ZONES].edit = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_CALENDAR_AVAILABILITIES].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_CALENDAR_AVAILABILITIES].edit = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_TRACKING_INCORRECT_MOVES].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_TRACKING_INCORRECT_MOVES].edit = SUPER_ADMIN_ONLY
authorizations[EmmaPath.REPORT_GENERAL].view = ADMIN_ONLY
authorizations[EmmaPath.REPORT_TUR].view = ADMIN_ONLY
authorizations[EmmaPath.REPORT_SALES].view = ADMIN_SALES_MANAGER
authorizations[EmmaPath.REPORT_SALES_PIPELINE].view = ADMIN_SALES_MANAGER
authorizations[EmmaPath.REPORT_REVENUE].view = ADMIN_SALES_MANAGER
authorizations[EmmaPath.REPORT_OVER_TIME].view = ADMIN_SALES_MANAGER
authorizations[EmmaPath.REPORT_SALES_DETAILS].view = ADMIN_SALES_MANAGER
authorizations[EmmaPath.REPORT_REVENUE_DETAILS].view = ADMIN_SALES_MANAGER
authorizations[EmmaPath.REPORT_SETTINGS].view = ADMIN_ONLY
authorizations[EmmaPath.REPORT_BILLABLE_EFFICIENCY].view = ADMIN_SALES_MANAGER
authorizations[EmmaPath.REPORT_CONTRACT_EFFICIENCY].view = ADMIN_SALES_MANAGER
authorizations[EmmaPath.REPORTS_MANAGER].view = ADMIN_ONLY
authorizations[EmmaPath.REPORTS_MARKETING].view = ADMIN_ONLY
authorizations[EmmaPath.CUSTOMER_CREATE].view = ADMIN_MANAGER_SALES
authorizations[EmmaPath.CUSTOMER_CREATE].edit = ADMIN_MANAGER_SALES
authorizations[EmmaPath.MOVER_MOVES].view = [RoleEnum.developer]
authorizations[EmmaPath.ADMIN_SERVICE_ZONES].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_SERVICE_ZONES].edit = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_MAP].edit = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_MAP].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_RELOCATION_TREND_MAP].edit = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_RELOCATION_TREND_MAP].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_CRON_JOBS].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_CRON_JOBS].edit = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_MOVES_MAP].edit = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_MOVES_MAP].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_BOOKING_SIMULATOR].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_BOOKING_SIMULATOR].edit = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_ESTIMATION_SIMULATOR].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_ESTIMATION_SIMULATOR].edit = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_REASSIGNMENT_FORM].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_REASSIGNMENT_FORM].edit = SUPER_ADMIN_ONLY
authorizations[EmmaPath.SALES_MANAGER_REVIEW] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_EMAIL_TEMPLATES] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_EMAIL_TEMPLATES_CREATE] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_EMAIL_TEMPLATES_UPDATE] = { edit: [], view: [] }
authorizations[EmmaPath.SALES_MANAGER_REVIEW].view = ADMIN_SALES_MANAGER
authorizations[EmmaPath.ADMIN_EMAIL_TEMPLATES].view = ADMIN_ONLY
authorizations[EmmaPath.ADMIN_EMAIL_TEMPLATES_CREATE].edit = ADMIN_ONLY
authorizations[EmmaPath.ADMIN_EMAIL_TEMPLATES_UPDATE].edit = ADMIN_ONLY
authorizations[EmmaPath.ADMIN_PERFORMANCE_LOG] = { edit: ADMIN_AND_MANAGER, view: ADMIN_AND_MANAGER }
authorizations[EmmaPath.ADMIN_ATTENDANCE_APPROVALS] = { edit: SUPER_ADMIN_ONLY, view: SUPER_ADMIN_ONLY }
authorizations[EmmaPath.ECP_QUICK_PRAISE_REDIRECTS] = {
  edit: [...ADMIN_MANAGER_SALES, RoleEnum.super_admin],
  view: [...ADMIN_MANAGER_SALES, RoleEnum.super_admin],
}
authorizations[EmmaPath.EMMA_LEADS] = { edit: [], view: [] }
authorizations[EmmaPath.EMMA_LEADS].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_DOCS] = { edit: [], view: [] }
authorizations[EmmaPath.ADMIN_DOCS].view = SUPER_ADMIN_ONLY
authorizations[EmmaPath.ADMIN_LEADFERNO_CONVERSION].view = ADMIN_ONLY
authorizations[EmmaPath.REPORT_MARKETING_DASHBOARD] = { edit: [], view: [] }
authorizations[EmmaPath.REPORT_MARKETING_DASHBOARD].view = ADMIN_MANAGER_SALES
authorizations[EmmaPath.REPORT_MARKETING_DASHBOARD].edit = ADMIN_ONLY

export type PageAccessOverrides = Record<string, { roles: RoleGroup }>

// Pages that ignore overrides: Settings hosts the page-access editor, so
// hiding it would leave no way to undo the change. Mirrored by the API.
export const PROTECTED_PAGE_PATHS: EmmaPath[] = [EmmaPath.REPORT_SETTINGS]

// Filled by MainLayout from the `pageAccess` constant (and its localStorage
// cache) so every existing caller of canView/userCanPerformAction sees the
// overrides without a signature change.
let pageAccessOverrides: PageAccessOverrides = {}
export const setPageAccessOverrides = (overrides: PageAccessOverrides): void => {
  pageAccessOverrides = overrides || {}
}
export const getPageAccessOverrides = (): PageAccessOverrides => pageAccessOverrides

export const effectiveViewRoles = (
  path: EmmaPath,
  overrides: PageAccessOverrides = pageAccessOverrides,
): { roles: RoleGroup; source: 'override' | 'default' } => {
  const override = PROTECTED_PAGE_PATHS.includes(path) ? undefined : overrides[path]
  if (override && Array.isArray(override.roles)) {
    return { roles: override.roles, source: 'override' }
  }
  return { roles: get(authorizations, `${path}.view`, []) as RoleGroup, source: 'default' }
}

export const canView = (
  userRoles: RoleGroup,
  path: EmmaPath,
  overrides: PageAccessOverrides = pageAccessOverrides,
): boolean => {
  const { roles, source } = effectiveViewRoles(path, overrides)
  // A custom list is authoritative for every role, super admins included,
  // so `[]` hides the page for everyone. Without one, super admins see all.
  if (source === 'override') {
    return intersection(roles, userRoles).length > 0
  }
  if (userRoles.includes(RoleEnum.super_admin)) return true
  if (size(roles)) {
    return intersection(roles, userRoles).length > 0
  }
  return size(userRoles) > 0
}

export const canEdit = (userRoles: RoleGroup, path: EmmaPath): boolean => {
  const allowed = get(authorizations, `${path}.edit`, []) as RoleGroup
  if (size(allowed)) {
    return intersection(allowed, userRoles).length > 0
  } else if (size(userRoles) > 0) {
    return true
  } else {
    return false
  }
}

export const userCanPerformAction = (isForEdit: boolean, roles: RoleGroup, path: EmmaPath): boolean => {
  if (isForEdit) {
    return canEdit(roles, path)
  }
  return canView(roles, path)
}
